/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
window.addEventListener('load', () => {
  const productSliders = document.querySelectorAll('.product-grid'); // Adjust the selector if needed
  productSliders.forEach(slider => {
    if (!slider.classList.contains('first-grid')) {
      slider.classList.add('hidden');
    }
  });
});
document.querySelectorAll('div[data-tab-target]').forEach(div => {
  div.addEventListener('click', handleTabClick);
});

function handleTabClick(event) {
  console.log("collection clicked");
  const clickedElement = event.target;

  // Check if the clicked element or any of its parents has the data-tab-target attribute
  if (clickedElement.closest('div[data-tab-target]')) {
    const targetId = clickedElement.closest('div[data-tab-target]').getAttribute('data-tab-target');
    const targetDiv = document.getElementById(targetId);
    console.log("target locked", targetId, targetDiv );
    // Hide all product grid items
    const productGridItems = document.querySelectorAll('.product-grid');
    productGridItems.forEach(item => item.classList.add('hidden'));

    // Toggle the "show" class on the target div
    targetDiv.classList.remove('hidden');
  }
}